<template>
  <div>
    <div class="contact-widget chat-widget hidden-xs"   >
      <div class="consult_item" style="padding: 10px 0 0 12px;">
        <ChatContainer v-if="nim && nim.showChat" class="footer-chat-con">
        </ChatContainer>
        <i v-if="!nim.showChat" @click="updateNim()" class="ico ico-qa pointer">
          <span v-if="nim.unread"></span>
        </i>
        <i style="margin: 9%;" v-else @click="updateNim()" class="ico ico-close pointer"></i>
      </div>
    </div>
  </div>
</template>

<script>
import ChatContainer from '../components/chat/ChatContainer'
export default {
  components: {
    ChatContainer
  },
  computed: {
    nim () {
      return this.$store.state.nim
    }
  },
  data () {
    return {
    }
  },
  methods: {
    updateNim () {
      this.$store.commit('updateNim', {showChat: !this.nim.showChat})
    }
  },
  watch: {
    $route(val, oldVal){
      this.$store.commit('updateNim', {showChat: false})
    }
  }
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .contact-widget {
    position: fixed;
    right: 130px;
    bottom: 30px;
    width: 110px;
    height: 50px;
    z-index: 998;
    background-color: #f3f3f9;
    border-radius: 999rem;
  }

  .consult_item {
    margin: 4%;
    /*box-shadow: 50px 2px 2px 2px #888888;*/
  }
  .qqgroup{
    position: fixed;
    right: 163px;
    bottom: 70px;
    text-align: center;
    border-radius: 2px;
    z-index: 998;
  }
  .weixingroup{
    position: fixed;
    right: 115px;
    bottom: 57px;
    text-align: center;
    border-radius: 2px;
    z-index: 998;
  }

  .chat-widget {
    right: 60px;
    width: 50px;
    height: 50px;
  }
  .chat-widget .consult_item {
    margin: 4% 0 0 2%;
  }

  .footer-chat-con {
    position: fixed;
    bottom: 90px;
    right: 60px;
    width: 100%;
    max-width: 380px;
  }
  .ico-qa {
    position: relative;
  }
  .ico-qa span {
    position: absolute;
    width: 8px;
    height: 8px;
    background-color: #d62104;
    border-radius: 100%;
    right: -8px;
    top: -10px;
  }
  @media (max-width: 768px) {
    .footer-chat-con {
      right: 0;
      bottom: 38px;
    }
    .chat-widget {
          right: 16px;
          width: 40px;
          height: 40px;
          bottom: 0px;
    }
    .chat-widget .consult_item {
      padding: 6px 0px 0px 7px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FloatingChat.vue